'use client';

import { useEffect, useState } from 'react';
import { useScroll } from '@overlapdev/hooks';
import { usePathname } from 'next/navigation';

const HeaderWrapper = ({ children, sticky }: { children: React.ReactNode; sticky?: boolean }) => {
	//__Hooks
	const [scrollPosition] = useScroll();
	const pathname = usePathname();

	//__State
	const [scroll, setScroll] = useState(0);

	//__Use Effects
	useEffect(() => {
		const main_path = pathname.split('/')[1];
		if (main_path === 'get-support') {
			document.body.classList.add('secondary');
			document.body.classList.remove('primary');
		} else if (main_path === 'get-involved') {
			document.body.classList.add('primary');
			document.body.classList.remove('secondary');
		} else {
			document.body.classList.remove('primary', 'secondary');
		}
	}, [pathname]);

	useEffect(() => {
		if (scrollPosition) {
			setScroll(parseFloat(scrollPosition.toString()));
		} else {
			setScroll(0);
		}
	}, [scrollPosition]);

	return (
		<div className={`header_wrapper duration-300 ease-out transition-colors w-full z-30 ${sticky ? 'bg-white border-b border-black/10 -mb-[1px] sticky text-black top-0' : scroll > 0 ? 'bg-white border-b border-black/10 fixed text-black top-0' : 'absolute border-transparent text-white top-0'}`}>
			{children}
			{sticky && scroll < 142 ? <div className='absolute bg-white h-full left-0 top-0 w-full -z-1' /> : null}
		</div>
	);
};

export default HeaderWrapper;
